import React from 'react';
import { useRecoilValue } from 'recoil';
import { productPackStepOptionState } from '../../../../../../utils/recoil/product';
import { Button } from '../../../../../UI/Elements';
import { Progress } from '../../../../../UI/Elements/Progress/progress';

export const ProductPackProgressBar = ({ idx, hanldeOptionDelete }) => {
  const productPackStepOption = useRecoilValue(productPackStepOptionState);
  const backIconColor = productPackStepOption[idx] === 2 ? 'primary' : 'white';
  return (
    <div className='flex items-center px-4'>
      <div className='mr-2'>
        <Button
          onClick={hanldeOptionDelete}
          size='lg'
          icon={{
            iconKey: 'HiChevronLeft',
            size: '3xl',
            color: { classname: backIconColor },
          }}
        />
      </div>
      <Progress index={idx} />
      <div className='ml-2'>
        <div className='w-10 p-1' />
      </div>
    </div>
  );
};
